export default {
  id: 122,
  title: 'Target #122 - Tetris',
  url: 'https://cssbattle.dev/play/122',
  colors: ['#173889', '#EE4F63', '#2CE1EA', '#F8DA37', '#B069F7'],
  solution:
    '<a><style>body{background:#173889}a{position:fixed;top:0;left:50;width:45;height:45;color:#ee4f63;box-shadow:0 255px #f8da37,51px 255px #2ce1ea,102px 255px #2ce1ea,153px 255px #2ce1ea,204px 255px #b069f7,255px 255px #2ce1ea,0 204px,51px 204px,102px 204px,153px 204px #2ce1ea,204px 204px #b069f7,255px 204px #b069f7,0 153px #f8da37,51px 153px #f8da37,102px 153px,204px 153px #b069f7,0 102px #f8da37,51px 102px #f8da37,153px 102px,153px 51px,204px 51px,204px 0}</style>',
}
